import { DataPoint } from '@liveoptics/react-ui/dist/types/interfaces/Charts';

export enum OverProvisioningGraphOption {  
  VCpu = 'vCPU',
  MemoryInGB = 'Memory (GiB)',
  CapacityInGB = 'Capacity (GiB)',
  FreePeakVcpu = 'PeakvCPU',
  AverageVcpu = 'AvgvCPU',
  PeakMemory = 'Peakmemory',
  AvgMemory = 'AvgMemory'
}

export interface OverProvisioningPoint extends DataPoint {
  Name: string;
  ProvisionedVCpu: number;
  UsedVCpu?: number;
  ProvisionedMemoryGB: number;
  UsedMemoryGB?: number;
  ProvisionedCapacityGB: number;
  UsedCapacityGB?: number;
  PeakVCpu?: number;
  AvgVCpu?: number;
  PeakMemoryGB?: number;
  AvgMemoryGB?: number;
}
